import { RemoteParticipantState } from "@azure/communication-react";
import * as reselect from "reselect";
import { getCallState } from "./baseSelectors";


const getRemoteParticipants = reselect.createSelector(
    [getCallState],
    state => state?.remoteParticipants
)

const filterPresenters =
    (remoteParticipants: Record<string, RemoteParticipantState> | undefined): Record<string, RemoteParticipantState> =>
        Object
            .entries(remoteParticipants ?? {} as Record<string, RemoteParticipantState>)
            .filter(([id, participant]) => participant.role === 'Presenter' || participant.role === 'Co-organizer' || participant.role === 'Organizer')
            .reduce((acc, [id, participant]) => ({...acc, [id]: participant}), {} as Record<string, RemoteParticipantState>);


/**
 * From all remoteParticipants,
 * select only those who are presenters, co-organizers, or organizers (= Moderator).
 */
export const selectPresenters = reselect.createSelector(
    [getRemoteParticipants],
    (remoteParticipantsState) => filterPresenters(remoteParticipantsState)
);

export const selectPresenterIds = reselect.createSelector(
    [selectPresenters],
    (presenters) => Object.keys(presenters)
);
